// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';
import classNames from '@ta/common.classnames';

import base from './SingleElementAnimation.less';
import styles from './FeaturedDestinationsLoadingSkeleton.less';

// Create a single element skeleton loader.
// .list will be repeated based on available space defined by .featuredDestinations height
const FeaturedDestinationsLoadingSkeleton = () => (
  <div className={classNames(base.animation, styles.featuredDestinations)}>
    <div className={styles.list} />
  </div>
);

export default FeaturedDestinationsLoadingSkeleton;
